import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatGBP } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/orders/${orderNumber}`).then(({ data }) => setOrder(data)).catch(() => setOrder(false));
  }, [orderNumber]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-20 text-center" data-testid="order-confirmation-page">
      <CheckCircle2 className="w-16 h-16 text-gold mx-auto" strokeWidth={1.4} />
      <h1 className="font-serif text-5xl mt-6 text-charcoal">Thank You!</h1>
      <p className="text-gray-500 mt-3">Your order has been placed successfully.</p>
      <p className="mt-2 text-sm">
        Order Reference: <span className="font-medium text-pink" data-testid="order-number">{orderNumber}</span>
      </p>

      {order && order.items && (
        <div className="bg-surface p-8 mt-10 text-left">
          <h2 className="font-serif text-2xl mb-5">Order Summary</h2>
          <div className="space-y-3">
            {order.items.map((item, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span>{item.name} <span className="text-gray-400">× {item.quantity}</span></span>
                <span>{formatGBP(item.line_total)}</span>
              </div>
            ))}
          </div>
          <div className="w-full h-px bg-gray-200 my-4" />
          <div className="flex justify-between text-sm"><span className="text-gray-500">Subtotal</span><span>{formatGBP(order.subtotal)}</span></div>
          {order.discount_amount > 0 && (
            <div className="flex justify-between text-sm mt-1 text-pink"><span>Discount ({order.discount_code})</span><span>−{formatGBP(order.discount_amount)}</span></div>
          )}
          <div className="flex justify-between text-sm mt-1"><span className="text-gray-500">Shipping</span><span>{order.shipping_cost === 0 ? "Free" : formatGBP(order.shipping_cost)}</span></div>
          <div className="flex justify-between text-lg font-medium mt-2"><span>Total</span><span>{formatGBP(order.total)}</span></div>
        </div>
      )}

      <p className="text-sm text-gray-500 mt-8">
        A confirmation email with your order details is on its way. We'll email you again with tracking once your order is dispatched.
      </p>
      <Link to="/" className="inline-block mt-8 bg-pink text-white px-9 py-4 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors">
        Continue Shopping
      </Link>
    </div>
  );
}
